import { createSlice } from "@reduxjs/toolkit";

import { getError } from "@/utils/get-error";
import { RootDetails } from "../../plant-overview/models/root-detail.dto";
import { getLadleOverviewTable, submitSetRootState } from "./ladles.thunks";

interface InitialState {
	roots: RootDetails[];
	isRootsLoading: boolean;
	isLookupTablesLoading?: boolean;
	error: string;
	ladleForModify?: {
		ladle?: RootDetails;
		isSetRootStateLoading: boolean;
		showModal: boolean;
		renderModal: boolean;
		error?: string;
	};
}

const initialState: InitialState = {
	error: "",
	roots: [],
	isRootsLoading: true,
};

export const LadlesReducer = createSlice({
	name: "@ladle-overview/general-table",
	initialState,
	reducers: {
		setLadleOvError(state, action) {
			state.error = action.payload;
		},
		setLadleForModify(state, action) {
			state.ladleForModify = {
				ladle: action.payload,
				isSetRootStateLoading: false,
				showModal: true,
				renderModal: true,
			};
		},
		closeLadleForModifyModal(state, action) {
			state.ladleForModify = {
				showModal: false,
				ladle: undefined,
				isSetRootStateLoading: false,
				renderModal: true,
			};
		},
		resetLadleForModify(state, action) {
			state.ladleForModify = {
				ladle: undefined,
				showModal: false,
				renderModal: false,
				isSetRootStateLoading: false,
			};
		},
		setRootSetStateError(state, action) {
			state.ladleForModify!.error = undefined;
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(getLadleOverviewTable.pending, (state, action) => {
				state.isRootsLoading = true;
			})
			.addCase(getLadleOverviewTable.fulfilled, (state, action) => {
				if (action.payload.error) {
					state.error = action.payload.message;
				} else {
					state.roots = action.payload.data as any;
					state.isRootsLoading = false;
				}
			})
			.addCase(getLadleOverviewTable.rejected, (state, action) => {
				state.roots = [];
				state.isRootsLoading = true;
			})
			// test
			.addCase(submitSetRootState.pending, (state, action) => {
				state.ladleForModify!.isSetRootStateLoading = true;
			})
			.addCase(submitSetRootState.fulfilled, (state, action) => {
				state.ladleForModify!.isSetRootStateLoading = false;
				state.ladleForModify!.showModal = false;
			})
			.addCase(submitSetRootState.rejected, (state, action) => {
				state.ladleForModify!.isSetRootStateLoading = false;

				const error = getError(action.payload);
				if (error) {
					state.ladleForModify!.error = error;
				}
			});
	},
});

export const {
	setLadleForModify,
	setLadleOvError,
	closeLadleForModifyModal,
	resetLadleForModify,
	setRootSetStateError,
} = LadlesReducer.actions;
